// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"4208ca2b","96":"92eda4e7","128":"71d5b088","152":"913ff994","200":"339bbf6e","428":"9282fb48","460":"e5862c74","528":"9f510d91","592":"0a6eb4d5"}[chunkId] + ".chunk.js";
};